import * as App from "@discovery/maestro";
import { getRealm as _getRealm } from "@discovery/client-core";
import { DEVELOPMENT_MODE, SONIC_ENDPOINT, SONIC_PROD_ENDPOINT, SONIC_DPLUS_INDIA_REALM, USE_REALM_SERVICE, AUTH_DOMAIN, AUTH_PROD_DOMAIN, } from "./env";
const useConfig = DEVELOPMENT_MODE === false || USE_REALM_SERVICE;
const staticDplusIndiaRealmConfig = {
    domain: SONIC_ENDPOINT || SONIC_PROD_ENDPOINT,
    realm: SONIC_DPLUS_INDIA_REALM,
    environment: "test",
    authDomain: AUTH_DOMAIN || AUTH_PROD_DOMAIN,
    // TODO figure out long term strategy for site selection
    siteLookupKey: "",
};
const staticDplusIndiaRealmApp = App.of(staticDplusIndiaRealmConfig);
export const getRealm = useConfig ? _getRealm() : staticDplusIndiaRealmApp;

